import { authFetch } from "~/services/fetch";
import { ClosingStatusResponse } from "../interface";

export async function getAllCategories(): Promise<readonly ClosingStatusResponse[]> {
  try {
    const { data } = await authFetch({
      url: '/dispatch/closed-status',
      method: 'GET',
    })
    return data;
  } catch (error) {
    throw error;
  }
}